import { Injectable, inject } from '@angular/core';
import { Observable, of, filter, map } from 'rxjs';

import { NavigationMenuItemDto } from '@common/data-services/navigation/models/navigation-menu-item.dto';

import { SidenavService } from '../../sidenav/sidenav.service';

@Injectable({
  providedIn: 'root'
})
export class AppLoaderNavigationService {
  private readonly sidenavService = inject(SidenavService);
  private cache = new Map<string, NavigationMenuItemDto | null>();

  /**
   * Resolves the navigation item for a given code.
   * Caches results to avoid duplicate navigation data fetching across guards/resolvers.
   */
  resolveNavigationItem(code: string | null): Observable<NavigationMenuItemDto | null> {
    // Return null immediately for invalid codes
    if (!code) {
      return of(null);
    }
    
    // Return cached result if available
    const cached = this.cache.get(code);
    if (cached !== undefined) {
      return of(cached);
    }

    return this.sidenavService.getNavigationData().pipe(
      filter(data => !!data),
      map(navigationData => {
        const navigationItem = this.findNavigationItemByCode(navigationData.NavigationItems, code);
        this.cache.set(code, navigationItem);
        return navigationItem;
      })
    );
  }

  private findNavigationItemByCode(items: NavigationMenuItemDto[], code: string): NavigationMenuItemDto | null {
    for (const item of items) {
      if (item.Code === code || item.State === `/next/app/${code}`) {
        return item;
      }

      if (item.HasChildren && item.Children?.length) {
        const found = this.findNavigationItemByCode(item.Children, code);
        if (found) {
          return found;
        }
      }
    }

    return null;
  }
}
